import { getApi } from "../../Shared/Services/RestService";
import { BIDashboardResponse } from "../Types/BIDashboardType";

export const getBIDashboard = () => {
  return getApi<BIDashboardResponse>("/admin/bi/dashboard");
};